<template>
  <div class="ibCommission-box">
    <!-- 组件头部： -->
    <div class="title-box">
      <!-- 模板管理 -->
      <h3 class="pull-left">{{ibCommissionLan.templateSetting}}</h3>
      <!-- 佣金预览： -->
      <div class="pull-right viewBtn-box" v-if="!showPreview">
        <!-- 对比浏览： -->
        <button class="double" @click="viewBtn = 'double'" >
          <span class="glyphicon glyphicon-list-alt"></span><span class="glyphicon glyphicon-list-alt"></span>
          {{ibCommissionLan.contrastBrowse}}
        </button>
        <!-- 单页浏览 -->
        <button @click="viewBtn = 'onlyOne'" >
          <span class="glyphicon glyphicon-list-alt"></span>
          {{ibCommissionLan.singlepageBrowse}}
        </button>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 组件主体： -->
    <div class="content-box">
      <!-- version0 已审核版本：最后计算佣金时用到这个版本的数据，不可修改 -->
      <div class="version0" :class="{'doubleView margin-right' : viewBtn === 'double'}" v-if="viewBtn=='double'">
        <!-- 子组件：代理佣金具体内容设定
          props通信传递数据：multiLanguage多语言、version版本号:0、viewBtn视图显示方式：对比浏览 or 单页浏览 -->
        <ib-template-setting-content
          :multiLanguage="ibCommissionLan"
          :version="'0'" 
          :curArea="curArea"
          :viewBtn="viewBtn"
          ref="version0">
        </ib-template-setting-content>
      </div>
      <!-- version1 已保存的版本：待审核的版本，可以修改 -->
      <div class="version1" :class="{'doubleView' : viewBtn === 'double'}">
        <!-- 子组件：代理佣金具体内容设定
          props通信传递数据：multiLanguage多语言、version版本号:1、viewBtn视图显示方式：对比浏览 or 单页浏览 -->
        <ib-template-setting-content
          :multiLanguage="ibCommissionLan"
          :version="'1'" 
          :viewBtn="viewBtn"
          :curArea="curArea"
          ref="version1"
          @afterVerify="afterVerifyFn">
        </ib-template-setting-content>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
  import ibTemplateSettingContent from './ibTemplateSettingContent' // 导入子组件 代理佣金具体内容设定

  export default {
    name: 'IBCommissionSetting',
    mixins: [
      require("common/mixin/base.js").base({ibCommissionLan:"ibCommission"}),
    ],
    props:['curArea'],
    components: {
      ibTemplateSettingContent,
    },
    data () {
      return {
        viewBtn: 'onlyOne',
        showPreview: false,
        currentTemplate: 'DEFAULT'
      }
    },
    methods: {
      afterVerifyFn () { // 审核成功后 再次刷新version0
        this.$refs.version0 && this.$refs.version0.pageInit('0')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .ibCommission-box{
    margin-top: 20px;
    padding-bottom: 20px;
    .title-box{
      border: 1px solid #3F51B5;
      margin: 0 20px;
      background: #3F51B5;
      padding: 0 20px;
      color: #fff;
      border-radius: 5px 5px 0 0;
      .preview-btn{
          margin-top: 12px;
          border: 1px solid #F08712;
          background-color: #F08712;
          height: 40px;
          padding: 0 10px;
          border-radius: 5px;
      }
      .viewBtn-box{
        margin: 12px 0 0 20px;
        line-height: 40px;
        height: 40px;
        box-sizing: border-box;
        text-align: right;
        span{
          font-size: 12px;
          font-weight: 700;
          color: #fff;
        }
        button{
          height: 40px;
          padding: 0 10px;
          color: #fff;
          border: 1px solid #fff;
          background: transparent;
          border-radius: 3px;
        }
        button:hover{
          box-shadow: inset 37px 37px 3px rgba(0, 0, 0, 0.125);
        }
        .double {
          margin-right: 20px;
        }
      }
    }
    .content-box{
      position: relative;
      margin: 0 20px 20px;
      padding:  20px 20px 0;
      border: 1px solid #ddd;
      background: #fff;
      .doubleView{
        float: left;
        width: 49%;
      }
      .margin-right{
        margin-right: 2%;
      }
      .version0{
        // border: 1px solid #ddd;
        margin-bottom: 20px;
        box-sizing: border-box;
      }
      .version1{
        // border: 1px solid #ddd;
        box-sizing: border-box;
        margin-bottom: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ibTemplateSetting.vue?a30b1106